import { unFormatCurrency, unFormatPercent, toFixed } from 'utils';

export const sumFunds = (policies: Array<{ fund_value: string | number }>) => {
  const results = policies.reduce(
    (policyA: any, policyB: any) => {
      const fundA = unFormatCurrency(policyA.fund_value);
      const fundB = unFormatCurrency(policyB.fund_value);

      return {
        fund_value: Number(fundA) + Number(fundB)
      };
    },
    { fund_value: 0 }
  );

  return Number(results.fund_value);
};

export const sumFundInitial = (
  policies: Array<{ fund_value_initial: string | number }>
) => {
  const results = policies.reduce(
    (policyA: any, policyB: any) => {
      const fundA = unFormatCurrency(policyA.fund_value_initial);
      const fundB = unFormatCurrency(policyB.fund_value_initial);

      return {
        fund_value_initial: Number(fundA) + Number(fundB)
      };
    },
    { fund_value_initial: 0 }
  );

  return Number(results.fund_value_initial);
};

export const sumTransferValue = (
  policies: Array<{ fund_value: string | number }>
) => {
  const results = policies.reduce(
    (policyA: any, policyB: any) => {
      const fundA = unFormatCurrency(policyA.transfer_value);
      const fundB = unFormatCurrency(policyB.transfer_value);

      return {
        transfer_value: Number(fundA) + Number(fundB)
      };
    },
    { transfer_value: 0 }
  );

  return Number(results.transfer_value);
};

export const sumRecommendedWeighting = (policies: Array<any>) => {
  const results = policies.reduce(
    (policyA: any, policyB: any) => {
      return {
        allocation:
          toFixed(unFormatPercent(policyA.allocation)) +
          toFixed(unFormatPercent(policyB.allocation))
      };
    },
    { allocation: 0 }
  );

  return Number(results.allocation);
};

export const sumExistingWeighting = (policies: Array<any>) => {
  const results = policies.reduce(
    (policyA: any, policyB: any) => {
      return {
        existing_weighting:
          toFixed(unFormatPercent(policyA.existing_weighting)) +
          toFixed(unFormatPercent(policyB.existing_weighting))
      };
    },
    { existing_weighting: 0 }
  );

  return Number(results.existing_weighting);
};
